export interface CategoryIsCollapsedArg {
  title?: string | null;
  description?: string | null;
  minGpa?: number | null;
  minPassingGradeForCourses?: number | null;
  completionRule?: {
    minUnits?: number | null;
  } | null;
  segmentLength: number | null;
  hasCategoryLevelErrors?: boolean;
}

/** If there is nothing to be shown on the category, then we collapse the container to be invisible */
const categoryIsCollapsed = ({
  title,
  description,
  minGpa,
  minPassingGradeForCourses,
  completionRule,
  segmentLength,
  hasCategoryLevelErrors = false,
}: CategoryIsCollapsedArg): boolean => {
  const completionRuleIsPresent = typeof completionRule?.minUnits === 'number';
  const segmentCountMatchesCompletionRule = completionRule?.minUnits === segmentLength;
  const categoryRequiresAllSegments = completionRuleIsPresent && segmentCountMatchesCompletionRule;
  return Boolean(
    !title &&
      !description &&
      typeof minGpa !== 'number' &&
      typeof minPassingGradeForCourses !== 'number' &&
      categoryRequiresAllSegments &&
      !hasCategoryLevelErrors
  );
};

export default categoryIsCollapsed;
